{
  "app": {
    "title": "SMS 庫存管理",
    "subtitle": "供應商 × 物流 × CoEldery 85",
    "language": "語言"
  },
  "nav": {
    "dashboard": "儀表板",
    "master": "主檔",
    "settings": "設定",
    "intake": "入庫",
    "build": "版本",
    "pending": "待收貨",
    "myShipments": "我嘅發貨單",
    "inventory": "庫存",
    "movements": "帳本",
    "outbound": "出庫",
    "weeklyFee": "倉租",
    "reports": "週報",
    "todo": "未完事項"
  },
  "common": {
    "loading": "載入中…",
    "loadFailed": "載入失敗，請重試",
    "save": "儲存",
    "saving": "儲存中…",
    "saved": "已儲存 ✓",
    "add": "新增",
    "adding": "新增中…",
    "refresh": "重新載入",
    "optional": "（選填）"
  },
  "setup": {
    "title": "首次登入：設定 Email ＋ 新密碼",
    "intro": "你好 {{name}}！呢個係第一次登入 —— 請設定你嘅 email 同新密碼，之後就用 email 登入。",
    "email": "Email",
    "emailHint": "之後用呢個 email ＋ 密碼登入（全系統唯一）。",
    "currentPassword": "現有密碼（預設）",
    "currentHint": "即係你第一次登入用嘅預設密碼。",
    "newPassword": "新密碼",
    "confirm": "再輸入新密碼",
    "policy": "最少 8 個字元；唔可以同預設密碼一樣。",
    "mismatch": "兩次輸入嘅新密碼唔一樣",
    "submit": "設定完成，開始用",
    "titleChange": "改 Email／密碼",
    "introChange": "{{name}}，你可以喺呢度改你嘅登入 email 同密碼（要入返現時密碼）。",
    "currentPasswordChange": "現時密碼",
    "newPasswordChange": "新密碼（唔想改就照填現時密碼）",
    "submitChange": "儲存",
    "currentEmail": "現時 email：{{email}}"
  },
  "po": {
    "intro": "向供應商落單：可以跟「安全庫存」建議補貨，落單之後供應商會確認接單（可改數量＋填 ETA）。",
    "supplierIntro": "CoEldery 85 向你落嘅採購單會出現喺呢度：可以確認接單（改數量＋填 ETA）或者出貨。",
    "shortageTitle": "低於安全庫存（建議補貨）",
    "shortageHint": "現時在倉（＝入 − 出）低過你設定嘅安全庫存就會列出；安全庫存喺「主檔 → 貨品」設定。",
    "shortageEmpty": "冇貨品低於安全庫存 ✓",
    "suggest": "建議補 {{n}} 箱",
    "newTitle": "開新採購單",
    "supplier": "供應商",
    "pick": "請選擇",
    "requestedAt": "要求到貨日（期望）",
    "requestedAtHint": "供應商確認時會填實際 ETA；呢個係你嘅期望，唔一定一樣。",
    "item": "貨品",
    "cartons": "箱數",
    "addLine": "加一行",
    "removeLine": "減一行",
    "note": "備註",
    "submit": "落單（草稿）",
    "created": "已開單 {{no}} ✓（記得撳「送出」通知供應商）",
    "listTitle": "採購單",
    "empty": "仲未有採購單。",
    "emptySupplier": "暫時冇 CoEldery 85 嘅採購單。",
    "eta": "預計到貨（ETA）",
    "onHand": "現時在倉",
    "safeLevel": "安全庫存",
    "ackHint": "⚠️ 只可以改細（唔可以加單）—— 改咗數量就一定要填原因。",
    "ackNote": "改動原因（改咗數量必填）",
    "ordered": "落單（箱）",
    "acked": "確認（箱）",
    "close": "收起",
    "linkedIntake": "已自動開發貨單 {{no}}（狀態 {{status}}）—— 物流會照原本流程收貨對數。",
    "status": {
      "draft": "草稿",
      "sent": "已送出",
      "ack": "已確認",
      "shipped": "已出貨",
      "received": "已收貨",
      "closed": "已完成",
      "cancelled": "已取消"
    },
    "act": {
      "send": "送出",
      "ack": "確認接單",
      "ship": "出貨",
      "receive": "已收貨",
      "close": "完單",
      "cancel": "取消"
    },
    "ask": {
      "cancel": "確定取消呢張採購單？"
    },
    "done": {
      "send": "已送出 ✓",
      "ack": "已確認接單 ✓",
      "ship": "已出貨（發貨單已自動開）✓",
      "receive": "已收貨 ✓",
      "close": "已完單 ✓",
      "cancel": "已取消 ✓"
    }
  },
  "tab": {
    "aria": "底部導覽",
    "menu": "選單",
    "language": "語言",
    "newVersion": "有新版本，請重新載入",
    "password": "改密碼",
    "account": "改 Email／密碼",
    "todo": "未完事項",
    "reports": "週報／匯出",
    "master": "主檔（供應商／貨品）",
    "ledger": "帳本",
    "settings": "設定（費率／目的地…）",
    "me": "我嘅資料",
    "orders": "訂單",
    "shipment": "出貨",
    "stock": "庫存",
    "incoming": "到貨",
    "pickup": "出貨指示",
    "fees": "倉租",
    "overview": "總覽",
    "purchase": "採購",
    "outbound": "出貨",
    "disposition": "貨去向"
  },
  "me": {
    "title": "我嘅資料",
    "intro": "你公司嘅基本資料（改完即刻生效）。",
    "code": "供應商代號",
    "codeHint": "⚠️ 代號係身分（單號／對數都用佢）—— 要改請搵 CoEldery 85 職員。",
    "name": "公司名",
    "contactName": "聯絡人",
    "contactPhone": "聯絡電話",
    "waNumber": "WhatsApp 號碼",
    "waHint": "國際格式（例 85291234567）—— 出庫通知會發去呢個號碼所屬嘅物流群組（P1-8）。",
    "saved": "已儲存 ✓",
    "attrsTitle": "自訂欄位",
    "attrsHint": "將來加嘅欄位會出現喺呢度（唔需要改資料庫；由管理員設定）。",
    "attrsEmpty": "暫時冇自訂欄位。"
  },
  "orders": {
    "title": "訂單",
    "intro": "CoEldery 85 向你落嘅採購單會出現喺呢度。",
    "buildingTitle": "⏳ 施工中（P1.5-B）",
    "buildingBody": "採購單功能正在開發：之後你會喺呢度見到單號、要幾多、要幾時到，並且可以「確認接單／改數量／填 ETA」。現階段請用「出貨」自己開發貨單。",
    "gotoShipments": "去「出貨」（開發貨單）→"
  },
  "purchase": {
    "title": "採購",
    "intro": "向供應商落單（按安全庫存建議數量）。",
    "buildingTitle": "⏳ 施工中（P1.5-B）",
    "buildingBody": "採購單功能正在開發：之後你可以喺呢度揀貨品、跟安全庫存建議補貨量落單，供應商確認之後先出貨。",
    "gotoOutbound": "去「出貨」（向物流落單）→"
  },
  "myItems": {
    "title": "我嘅貨品",
    "hint": "你嘅貨品清單（cbm 由箱尺寸自動算）。開新貨品之後，就可以喺「出貨」開單。",
    "add": "＋ 新增貨品",
    "hideAdd": "收起新增表單",
    "empty": "仲未有貨品 —— 撳上面「＋ 新增貨品」加第一件。",
    "unitsPerCarton": "每箱件數",
    "cartonSize": "箱尺寸（長×闊×高）",
    "cbmPerCarton": "每箱 cbm",
    "safeLevel": "安全庫存（箱）",
    "inactive": "已停用"
  },
  "pwd": {
    "title": "改密碼",
    "intro": "改完之後，你其他裝置嘅登入會即刻失效（呢部裝置唔會）。",
    "current": "舊密碼",
    "next": "新密碼",
    "confirm": "再輸入新密碼",
    "policy": "最少 8 個字元；唔可以用常見弱密碼。",
    "mismatch": "兩次輸入嘅新密碼唔一樣",
    "submit": "改密碼",
    "done": "已改密碼 ✓",
    "back": "返回 →"
  },
  "stock": {
    "formulaTitle": "庫存計法：入 − 出 ＝ 現時",
    "formulaHint": "入庫（入到倉）減出庫（離開倉）＝ 現時倉庫量。三個角色睇嘅係同一本帳本，所以數字一定一致。",
    "scoped": "你只會見到自己嘅貨（夥伴資料隔離）。",
    "in": "入庫",
    "out": "出庫",
    "current": "現時倉庫量",
    "ok": "帳本自洽 ✓",
    "mismatch": "⚠️ 公式同餘額唔一致（請通知職員查）",
    "empty": "仲未有貨品記錄。",
    "sku": "貨品",
    "inCartons": "入（箱）",
    "inCbm": "入（cbm）",
    "outCartons": "出（箱）",
    "outCbm": "出（cbm）",
    "currentCartons": "現時（箱）",
    "currentCbm": "現時（cbm）",
    "balanceCbm": "餘額核對（cbm）"
  },
  "home": {
    "healthTitle": "系統狀態",
    "checking": "檢查中…",
    "dbUp": "資料庫連線正常",
    "dbUnbound": "資料庫未綁定（本機開發請跑 npm run dev:cf）",
    "apiDown": "API 無回應"
  },
  "dash": {
    "title": "儀表板",
    "intro": "今日要處理嘅事（依你嘅角色顯示；冇顯示嘅代表唔關你事）",
    "scoped": "你只會見到自己嘅貨同單（夥伴資料隔離）",
    "pendingIntake": "待收貨（批）",
    "pendingOutbound": "待出貨（單）",
    "weekCbm": "本週 cbm（計費基礎）",
    "weekCbmHint": "期初制：{{week}} 嘅在倉量",
    "unconfirmedFees": "待確認倉租（週）",
    "unsettledEvents": "⚠️ 未結算場次",
    "unsettledEventsHint": "直銷場已交收但未做場後結算",
    "missingChop": "⚠️ 缺交收證據",
    "missingChopHint": "送貨已交收但未有客戶印章／簽名相",
    "onSiteCbm": "在場 cbm",
    "pendingTitle": "未完事項",
    "seeAllPending": "睇全部未完事項 →"
  },
  "pending": {
    "title": "未完事項",
    "intro": "要人跟嘅清單：未結算場次／缺交收證據／在場庫存（目標 ＝ 冇一張出庫單失蹤）",
    "summary": "未結算 {{events}} 場 · 缺證據 {{chop}} 單 · 在場 {{cbm}} cbm",
    "unsettledTitle": "未結算場次",
    "unsettledHint": "直銷場（direct_sale）已交收但未做場後結算 → 帳未出齊",
    "unsettledEmpty": "冇未結算場次 ✓",
    "missingChopTitle": "缺交收證據",
    "missingChopHint": "送貨（delivery）已交收但未有「客戶印章／簽名」相（可以後補上載）",
    "missingChopEmpty": "全部送貨單都有交收證據 ✓",
    "missingChopBadge": "⚠️ 缺章簽相",
    "onSiteTitle": "在場庫存",
    "onSiteHint": "仲留喺場地（roadshow）未搬走嘅貨",
    "onSiteEmpty": "冇貨留喺場地 ✓",
    "cartons": "箱",
    "units": "件",
    "cbm": "cbm",
    "skus": "款",
    "deliveredAt": "交收",
    "openOrder": "去處理",
    "reload": "重新載入"
  },
  "report": {
    "title": "週報／匯出",
    "intro": "倉租明細 ＋ 出入庫摘要（數字直接由倉租模組同帳本出，唔會另計一套）",
    "week": "週（星期一）",
    "prevWeek": "上一週",
    "nextWeek": "下一週",
    "thisWeek": "今週",
    "exportXlsx": "匯出 Excel（.xlsx）",
    "exportCsv": "匯出 CSV",
    "exported": "已匯出 {{name}}",
    "sheetFee": "倉租明細",
    "sheetLedger": "出入庫摘要",
    "sheetBatches": "入庫批次",
    "sheetPending": "未完事項",
    "feeTitle": "倉租明細",
    "feeHint": "期初 cbm × 儲存費率 ＋ 該週入庫手續費（期初制；週中出入庫唔影響該週）",
    "ledgerTitle": "出入庫摘要",
    "ledgerHint": "帳本（stock_movements）按移動類別彙總 —— 唯一真相源",
    "batchTitle": "入庫批次",
    "batchHint": "該週收貨嘅批次（手續費歸屬週）",
    "type": "類別",
    "count": "筆數",
    "cartons": "箱",
    "units": "件",
    "cbm": "cbm",
    "status": "狀態",
    "batchNo": "發貨單號",
    "supplier": "供應商",
    "receivedDate": "收貨日",
    "receivedCbm": "實收 cbm",
    "handlingFee": "手續費",
    "item": "項目",
    "value": "數量",
    "notGenerated": "未產生",
    "generatedAt": "產生於",
    "matchesOk": "（同即時重算一致 ✓）",
    "matchesBad": "（⚠️ 同即時重算唔一致）",
    "issues": "⚠️ ",
    "noLedger": "今週帳本未有任何移動",
    "noBatch": "今週未有入庫批次",
    "pendingLine": "未完事項：未結算 {{events}} 場 · 缺交收證據 {{chop}} 單",
    "gotoFees": "去產生／確認倉租 →"
  },
  "login": {
    "title": "登入",
    "username": "帳號",
    "identifier": "Email 或 帳號",
    "identifierHint": "第一次登入用帳號（例 S0001）；設定完 email 之後，用 email 登入。",
    "password": "密碼",
    "submit": "登入",
    "submitting": "登入中…",
    "failed": "登入失敗，請再試",
    "logout": "登出",
    "welcome": "你好，{{name}}"
  },
  "role": {
    "supplier": "供應商",
    "logistics": "物流夥伴",
    "staff": "CoEldery 85 職員",
    "admin": "管理員"
  },
  "master": {
    "title": "主檔：供應商／貨品",
    "suppliersTitle": "供應商（貨主）",
    "itemsTitle": "貨品（SKU）",
    "code": "供應商代號",
    "name": "名稱",
    "contactName": "聯絡人",
    "contactPhone": "聯絡電話",
    "waNumber": "WhatsApp 號碼",
    "addSupplier": "新增供應商",
    "supplierCreated": "已新增供應商 ✓",
    "supplier": "供應商",
    "filterSupplier": "篩選供應商",
    "allSuppliers": "全部供應商",
    "itemName": "貨品名稱",
    "barcode": "條碼",
    "unitsPerCarton": "每箱件數",
    "cartonDims": "箱尺寸",
    "cartonL": "箱長（cm）",
    "cartonW": "箱闊（cm）",
    "cartonH": "箱高（cm）",
    "cbmOverride": "cbm 覆寫",
    "weightKg": "每箱重量（kg）",
    "cbm": "每箱 cbm",
    "cbmPerUnit": "每件 cbm",
    "addItem": "新增貨品",
    "pickSupplierFirst": "⚠️ 請先揀供應商（撳唔到「新增貨品」就係因為未揀）",
    "itemCreated": "已新增貨品 ✓",
    "photo": "相片",
    "uploadPhoto": "上載相片",
    "photoUploading": "上載中…",
    "photoUploaded": "相片已上載 ✓",
    "noPhoto": "未有相",
    "emptySuppliersTitle": "未有供應商",
    "emptySuppliersBody": "先新增一個貨主，之後就可以入貨品。",
    "emptyItemsTitle": "未有貨品",
    "emptyItemsBody": "揀一個供應商，再入第一件貨。",
    "hintCbm": "每箱 cbm 由尺寸自動算（長×闊×高÷1,000,000），倉租就係用呢個數。",
    "hintBarcode": "一個條碼一件貨（全系統唯一）。",
    "hintOverride": "淨係尺寸唔準嘅時候才填；填咗就以呢個為準。"
  },
  "settings": {
    "title": "設定（後台）",
    "note": "費率／結算日／WhatsApp 設定一律喺呢度改 —— 代碼唔會寫死。",
    "save": "儲存設定",
    "saved": "已儲存 ✓",
    "saveFailed": "儲存失敗",
    "feeHandlingPerCbm": "入庫手續費（每 cbm，HK$）",
    "feeStoragePerCbmWeek": "倉租（每 cbm 每週，HK$）",
    "settlementWeekday": "每週結算日",
    "feeFirstStorageFrom": "起租日（首批貨到倉日）",
    "hintFirstStorageFrom": "空白 ＝ 冇特例。設定咗：該日所屬結算週期嘅期初「含當日」（例：2026-09-23 到倉 → 9/23–9/29 該週就收 61.4 × 倉租費率）。",
    "waTemplateOutbound": "出庫通知 template 名",
    "waTemplatePicked": "已執貨通知 template 名",
    "waTemplateLang": "template 語言",
    "waMaxItemsInMessage": "訊息最多列幾多項貨品",
    "waRecipients": "WhatsApp 收訊人（電話）",
    "waRecipientsStaff": "落單人 WhatsApp 收訊人（電話）",
    "outboundOrderNoPrefix": "出庫單編號前綴",
    "outboundDeliveryCodePrefix": "送貨碼前綴",
    "intakeBatchNoPrefix": "入庫批次前綴",
    "weekday1": "星期一",
    "weekday2": "星期二",
    "weekday3": "星期三",
    "weekday4": "星期四",
    "weekday5": "星期五",
    "weekday6": "星期六",
    "weekday7": "星期日",
    "hintRecipients": "只填數字含國碼（例 85291234567）；多個用逗號分隔。",
    "hintRecipientsStaff": "執貨完成後通知落單人（職員）；要先用已批准嘅已執貨 template；只填數字含國碼。",
    "hintTemplate": "要同 Meta 已批准嘅 template 名一模一樣。",
    "hintTemplatePicked": "執貨完成通知用嘅 template（例 sms_outbound_picked）；未批准之前唔會發。",
    "appBaseUrl": "系統對外網址（WhatsApp 連結用）",
    "hintBaseUrl": "例 https://sms.85ai.app —— WhatsApp 通知嘅「開啟系統」按鈕就係用呢個；⚠️ 唔好用 *.pages.dev（每次部署會換）"
  },
  "order": {
    "linkTitle": "出庫指示 {{orderNo}}",
    "linkBody": "你由 WhatsApp 通知㩒入嚟。下面會自動搵返呢張出庫單；要執貨就撳「去執貨清單」。",
    "lookingUp": "搵緊呢張出庫單…",
    "notFound": "搵唔到 {{orderNo}} 呢張單（可能未建立，或者單號打錯）。",
    "noAccess": "你嘅帳號冇出庫權限（出庫流程只限物流／職員／管理員）。",
    "openOrder": "睇出庫單",
    "startPick": "去執貨清單",
    "goHome": "去主頁"
  },
  "intake": {
    "titleSupplier": "我嘅發貨單",
    "titleLogistics": "入庫／待收貨",
    "newBatch": "新增發貨單",
    "batchNo": "批次號",
    "supplier": "供應商",
    "declaredShipDate": "送貨日期",
    "receivedDate": "收貨日（起算日）",
    "status": "狀態",
    "declaredCbm": "申報 cbm",
    "receivedCbm": "入庫 cbm",
    "handlingFee": "入庫手續費",
    "note": "備註",
    "items": "貨品",
    "item": "貨品",
    "pickItem": "揀貨品",
    "declaredCartons": "申報箱數",
    "receivedCartons": "實收箱數",
    "damagedCartons": "損壞箱數",
    "productionDate": "生產日期",
    "expiryDate": "到期日",
    "addLine": "加一項貨",
    "removeLine": "刪除",
    "create": "建立發貨單",
    "created": "已建立發貨單 ✓",
    "needLine": "至少要有一項貨（每行要揀貨品 ＋ 填箱數）",
    "verify": "確認收貨（即時入帳）",
    "verifying": "入帳中…",
    "verified": "已收貨入帳 ✓",
    "verifyHint": "實收同申報唔同 → 一定要填原因；有損壞 → 一定要上載箱相。",
    "diffReason": "差異原因",
    "damagePhoto": "損壞箱相",
    "uploadDamage": "上載箱相",
    "uploading": "上載中…",
    "uploaded": "已上載 ✓",
    "damageNeedPhoto": "有損壞就要上載箱相（規則要求）",
    "statusDeclared": "已申報（未收貨）",
    "statusReceived": "已收貨",
    "statusVerified": "已對數",
    "statusDiscrepancy": "有差異",
    "statusCancelled": "已取消",
    "filterStatus": "篩選狀態",
    "allStatus": "全部狀態",
    "emptyTitle": "未有發貨單",
    "emptyBody": "供應商開第一張發貨單，物流就會見到。",
    "emptyPendingTitle": "暫時冇待收貨",
    "emptyPendingBody": "有供應商申報之後，呢度會出現。",
    "open": "查看",
    "back": "返列表",
    "detailTitle": "發貨單詳情",
    "readOnly": "只有物流／職員／管理員可以做收貨對數。",
    "damagedNote": "損壞貨入倉內損壞區：照計倉租、但唔會出貨。",
    "lineNoItem": "第 {{n}} 行：未揀貨品 —— 要喺「貨品」下拉揀一件（冇得揀就先撳「新增貨品」）",
    "lineNoCartons": "第 {{n}} 行：箱數未填（要 1 或以上）",
    "itemAddedLine": "已自動加入「{{name}}」落發貨單 —— 請填箱數",
    "addItemFirst": "先加一件貨品",
    "itemsTitle": "貨品（逐項）",
    "addItemToggle": "＋ 新增貨品"
  },
  "loc": {
    "warehouse": "物流倉",
    "damaged": "損壞區",
    "office": "辦公室",
    "supplier": "供應商（未出貨）",
    "writtenOff": "已註銷"
  },
  "inv": {
    "title": "庫存餘額",
    "intro": "顯示每個位置而家有幾多貨。cbm 係計費基礎；損壞貨未離開倉一樣照計租。",
    "rowsTitle": "各位置餘額",
    "mirrorHidden": "已收起 {{n}} 行「帳本對沖」（負數 ＝ 帳本另一邊，唔係實際存量）",
    "showMirror": "顯示帳本對沖行",
    "mirrorHint": "⭐ 為何有負數：每次入庫只寫一筆移動「供應商 → 物流倉」，而位置餘額係逐個位置嘅淨數 → 來源位置（例：供應商未出貨）一定係等量負數。全部位置加埋 ＝ 0 屬正常，亦唔影響倉租（計租只有物流倉 ＋ 損壞區）。",
    "filterLocation": "位置",
    "allLocations": "全部位置",
    "filterSupplier": "供應商",
    "allSuppliers": "全部供應商",
    "includeEmpty": "連已清空（0 箱）嘅位置都顯示",
    "summaryWarehouse": "倉內 cbm（計租基礎）",
    "summaryWarehouseHint": "＝ 物流倉 ＋ 損壞區（decisions/003）",
    "summaryDamaged": "其中損壞區 cbm",
    "summaryCounts": "貨品 ／ 批次",
    "summaryCountsHint": "獨立貨品數 ／ 貨品・批次組合數",
    "byLocationTitle": "各位置明細（負數 ＝ 已離開嗰個位置，正常）",
    "invariantBad": "⚠️ 帳本唔自洽：全部位置 cbm 總和 ＝ {{net}}（應該 ≈ 0）→ 請即刻查帳本",
    "scopedNotice": "你只會見到自己嘅貨（供應商範圍，後端把關）。",
    "emptyTitle": "暫時冇庫存",
    "emptyBody": "物流做完收貨對數之後，餘額會即時出現喺呢度。",
    "batch": "批次",
    "cartons": "箱",
    "units": "件"
  },
  "mov": {
    "title": "庫存帳本",
    "intro": "帳本係唯一真相源，只可以追加（要更正 ＝ 另開一筆「更正」，唔准改舊記錄）。",
    "filterType": "類型",
    "allTypes": "全部類型",
    "from": "由",
    "to": "至",
    "typeIn": "入庫",
    "typeOut": "出庫",
    "typeSale": "售出",
    "typeTransfer": "調撥",
    "typeAdjust": "更正",
    "actor": "經手人",
    "ref": "來源",
    "emptyTitle": "暫時冇帳目",
    "emptyBody": "入庫對數之後，第一筆帳目就會出現。",
    "prev": "上一頁",
    "next": "下一頁",
    "pageInfo": "第 {{page}}／{{last}} 頁（共 {{total}} 筆）"
  },
  "out": {
    "title": "出庫單",
    "newOrder": "新增出庫單",
    "newHint": "直銷場出貨揀「直銷」；送貨／樣品揀「送貨」。cbm 一律由系統計（前端唔會自己乘）。",
    "create": "建立出庫單",
    "back": "返列表",
    "backToOrder": "返出庫單",
    "emptyTitle": "未有出庫單",
    "emptyBody": "職員開第一張出庫單之後，呢度就會出現。",
    "filterStatus": "篩選狀態",
    "filterKind": "篩選類型",
    "allStatus": "全部狀態",
    "allKinds": "全部類型",
    "kind": "出庫類型",
    "kindDirectSale": "直銷場",
    "kindDelivery": "送貨",
    "destination": "去向",
    "deliveryMode": "取貨方式",
    "modeSelfPickup": "自取",
    "modeLogistics": "物流運送",
    "pickupAt": "取貨時間",
    "hintPickupAt": "WhatsApp 通知會寫住呢個時間；送貨單請填實際送達時段。",
    "consignee": "收貨方",
    "address": "地址",
    "note": "備註",
    "lines": "出庫貨品",
    "item": "貨品",
    "itemCount": "貨品項數",
    "pickItem": "揀貨品",
    "batch": "批次",
    "batchAuto": "自動（先到先出）",
    "cartons": "箱數",
    "cbm": "cbm",
    "warehouseAvailable": "倉內可用 {{n}} 箱",
    "addLine": "加一項貨",
    "removeLine": "刪除",
    "hintCartons": "出庫一律整箱；唔揀批次 ＝ 系統按最早到期自動分派（同一件貨跨批次會自動拆行）；倉內唔夠貨嘅話開單會被拒（要先入庫）。",
    "noItems": "主檔未有任何貨品，請先去主檔新增。",
    "needDestination": "請揀去向",
    "needPickupAt": "請填取貨時間",
    "needConsignee": "請填收貨方",
    "needLine": "至少要有一項貨",
    "required": "必填",
    "detailTitle": "出庫單詳情",
    "deliveryCode": "送貨碼",
    "waSentAt": "通知發出時間",
    "pickedAt": "執貨日",
    "toLoc": "執貨去邊",
    "outboundCbm": "出庫 cbm",
    "summary": "執貨摘要",
    "declaredCartons": "申報箱數",
    "picked": "已執箱數",
    "pickedCartons": "實際執到（箱）",
    "pendingLines": "未執行數",
    "shortfall": "執少箱數",
    "pickDiscrepancy": "執貨差異",
    "next": "下一步",
    "statusDraft": "草稿（未通知）",
    "statusSent": "已通知（等執貨）",
    "statusAcknowledged": "已執貨（等交收）",
    "statusDelivered": "已交收",
    "statusReconciled": "已結算（待完單）",
    "statusClosed": "已完成",
    "statusCancelled": "已取消",
    "sendTitle": "WhatsApp 出庫通知",
    "sendHint": "發通知之後，對方 WhatsApp 會收到取貨時間 ＋「開啟系統」按鈕；發出 ＝ 狀態轉「已通知」，之後才准執貨。",
    "send": "發出通知",
    "sending": "發送中…",
    "preview": "預覽（唔發）",
    "previewResult": "預覽結果（未發送）",
    "template": "範本",
    "lang": "語言",
    "deepLink": "連結",
    "recipients": "收訊人（遮蔽）",
    "sendOk": "已發出通知 ✓",
    "sendFailed": "發送失敗：狀態仍然係草稿，可以改完再發",
    "needStaffToSend": "發通知只有職員／管理員可以做。",
    "goPick": "去執貨",
    "picklistTitle": "執貨清單",
    "pickOnlyWhenSent": "要「已通知」之後才准執貨（通知未發 ＝ 對方唔知有貨）。",
    "pickDone": "✓ 已執貨 —— 客人嚟攞貨／送到目的地時，撳下面嗰個掣完成交收（日期會記低今日）。",
    "pickClosed": "呢張單已經交收（下一步由 CoEldery 85 職員處理）。",
    "awaitingHandover": "⏳ 待交收",
    "goHandOver": "去交收",
    "confirmPick": "確認執貨（即時出帳）",
    "pickInvalid": "實際執到箱數要係 0 或以上嘅整數",
    "pickTooMany": "唔准執多過申報（{{n}} 箱）；要多出 ＝ 另開一張新單",
    "pickNeedReason": "執少一定要填原因",
    "pickNote": "原因／備註",
    "pickNoteRequired": "原因（執少必填）",
    "cancel": "取消出庫單",
    "cancelConfirm": "確定取消出庫單 {{orderNo}}？（取消之後唔可以再執貨）",
    "cancelledHint": "呢張單已取消。",
    "needsReconciliation": "直銷場交收完仲要場後結算（賣出／剩貨／損壞 ＋ 剩貨去向）才准完單。",
    "deliverTitle": "交收一掣",
    "deliverHintDelivery": "送貨／樣品：撳一下即完單（日期、帳目、通知由系統處理）。",
    "deliverHintSale": "直銷場：撳一下 ＝ 「已交收」；之後由 CoEldery 85 職員做場後結算。",
    "deliver": "確認交收",
    "collectNow": "已收貨",
    "deliverNow": "已送貨",
    "deliverSale": "已交收（場務）",
    "deliverOneTapAsk": "確定「{{what}}」？（交收日期 ＝ 今日；之後唔可以再改）",
    "deliverNoteOptional": "＋加備註（可選）",
    "delivered": "已交收 ✓",
    "deliveredAt": "交收日",
    "deliverNote": "交收備註",
    "needStaffToReconcile": "呢張單交收之後由 CoEldery 85 職員做場後結算／完單（倉已完成）。",
    "printDeliveryNote": "列印送貨單（PDF）",
    "printDeliveryNoteHint": "送貨單由系統產生（含送貨碼），開新分頁之後用瀏覽器列印／另存 PDF。收貨方簽署／蓋章之後，影相上載做交收證據。",
    "evidence": "交收證據（送貨單連章／簽名）",
    "missingEvidence": "⚠️ 缺交收證據：未上載「有客戶印章／簽名嘅送貨單」相 —— 未算完成。",
    "missingEvidenceShort": "缺交收證據",
    "evidenceOk": "✓ 已有交收證據（客戶印章／簽名相）。",
    "evidenceNotYet": "交收之後補上「有客戶印章／簽名嘅送貨單」相（唔需要即場影）。",
    "evidenceSupplierNoAccess": "交收證據只有物流／職員／管理員睇得到。",
    "chopPhoto": "送貨單（連章簽名）相",
    "uploadChop": "上載送貨單相（後補）",
    "uploadChopHint": "影「有客戶印章／簽名」嘅送貨單全張（JPEG／PNG／WebP，≤5 MB）。⚠️ 證據只可以新增，唔可以刪除或覆寫。",
    "uploadFailed": "上載失敗",
    "uploaded": "已上載 ✓",
    "copied": "已複製 ✓",
    "copyLink": "複製連結",
    "copyFailed": "複製失敗，請手動複製"
  },
  "recon": {
    "title": "場後結算",
    "intro": "直銷場交收完要逐項對數：賣出 ＋ 剩貨 ＋ 損壞 一定要等於實際執到（箱同散件都要），對得上才准確認入帳。",
    "backToOrder": "返出庫單",
    "goReconcile": "去結算",
    "goClose": "去完單",
    "savedLines": "已結算項目",
    "savedDraft": "已存草稿（未入帳）✓",
    "confirmed": "已確認入帳 ✓（狀態轉「已結算」）",
    "confirmedAt": "確認時間",
    "onlyDirectSale": "只有直銷場單要場後結算（送貨單送達即完單）。",
    "needStaffToClose": "完單只有職員／管理員可以做。",
    "closedHint": "呢張單已完成（帳已入，唔可以再改）。",
    "closeOrder": "完單",
    "closeAsk": "確定完單 {{orderNo}}？（完單之後唔可以再改結算）",
    "closedOk": "已完單 ✓",
    "toLoc": "落點",
    "sold": "賣出",
    "leftover": "剩貨",
    "damaged": "損壞",
    "cartons": "箱",
    "units": "件",
    "outCartons": "出庫（實際執到）",
    "declaredCartons": "申報",
    "unitsPerCarton": "每箱件數",
    "outUnits": "出庫 {{n}} 件",
    "balanced": "對得上 ✓",
    "unbalanced": "對唔上（差 {{n}} 件）",
    "balancedOk": "全部項目對得上，可以確認入帳。",
    "unbalancedLines": "仲有 {{n}} 行對唔上（或未填齊）—— 唔准確認。",
    "balanceHint": "鐵律：賣出 ＋ 剩貨 ＋ 損壞 ＝ 出庫量（箱 × 每箱件數 ＋ 件）。損壞要填原因；退回物流倉只准未開箱整箱。",
    "disposition": "剩貨去向",
    "dispositionRequired": "有剩貨就一定要揀去向",
    "pickTarget": "請揀…",
    "targetOrder": "轉去邊張出庫單",
    "targetStore": "轉去邊間店",
    "toLocPreview": "落點（預覽）：{{loc}}",
    "backToWarehouseHint": "退物流倉只准未開箱整箱 —— 散件要揀其他去向。",
    "note": "備註",
    "noteRequired": "原因（損毀註銷必填）",
    "summary": "對數摘要",
    "summaryLines": "對得上：{{ok}}／{{total}} 行",
    "missingDisposition": "{{n}} 行未揀去向",
    "draftHint": "草稿已存（未入帳）—— 確認之後才出帳同轉「已結算」。",
    "saveDraft": "儲存草稿",
    "confirm": "確認入帳",
    "confirmHint": "確認 ＝ 一次過出帳（賣出 SALE／剩貨 TRANSFER／損壞 ADJUST），之後唔可以再改。",
    "confirmAsk": "確定確認入帳 {{orderNo}}？（確認之後唔可以再改）",
    "needAllRows": "未入得住",
    "venue": "場地名稱",
    "reportedAt": "場次日期",
    "movements": "結算產生嘅帳目",
    "movementsEmpty": "仲未有帳目 —— 確認入帳之後，呢度會列出（亦可以喺庫存帳本睇）。",
    "movementSale": "售出（SALE）",
    "movementTransfer": "調撥（TRANSFER）",
    "movementAdjust": "更正（ADJUST）",
    "viewLedger": "去庫存帳本"
  },
  "weeklyFee": {
    "title": "每週倉租",
    "intro": "逢星期一結算物流倉租；計費基礎係該週期初 cbm（整週照收、唔按日計）。",
    "ratesTitle": "費率（後台設定）",
    "storageRate": "儲存費（每 cbm／週）",
    "handlingRate": "入庫手續費（每 cbm）",
    "settlementWeekday": "結算日（星期）",
    "weekdayMismatch": "⚠️ 設定嘅結算日唔係星期一 —— 同期初制（逢週一）矛盾，請去設定頁更正。",
    "currentWeek": "今週（{{week}}）",
    "openingCbm": "期初 cbm（計費基礎）",
    "outboundCbm": "本週出庫 cbm",
    "closingCbm": "期末 cbm",
    "storageAmount": "儲存費",
    "handlingAmount": "手續費",
    "totalAmount": "合計",
    "issues": "完整性問題：",
    "generate": "產生／重算本週倉租",
    "generateHint": "只准星期一、唔准未來週；已確認嘅週唔准改（更正要另開調整紀錄）。",
    "regenerated": "已重算草稿 ✓",
    "generated": "已產生 ✓",
    "confirm": "確認入帳",
    "confirmAsk": "確認之後金額唔准再改（更正要另開調整紀錄），確定確認 {{week}} 呢個星期？",
    "confirmedOk": "已確認 ✓",
    "readOnlyHint": "（物流：你可以核對但唔可以改數字 —— 有問題請喺下面「確認」時寫備註，或者直接同職員講）",
    "skuTitle": "逐個 SKU 嘅期初 cbm（核對用）",
    "skuHint": "加埋 ＝ 上面「期初 cbm（計費基礎）」；cbm ＝ 箱尺寸自動算（唔靠人手估）。",
    "skuEmpty": "今週期初仲未有任何貨喺倉。",
    "skuCode": "供應商",
    "skuName": "貨品",
    "skuBarcode": "條碼",
    "skuCartons": "箱",
    "skuCbm": "期初 cbm",
    "ack": "確認冇問題",
    "ackAsk": "{{week}} 呢個星期嘅 cbm 同價錢 —— 可以加備註（例：對得上／邊項有疑問）：",
    "ackOk": "已記錄你嘅確認 ✓",
    "acksTitle": "確認紀錄",
    "acksHint": "每次確認都會留痕（邊個、幾時、備註）；⚠️ 呢個動作**唔會**改任何金額。",
    "acksEmpty": "仲未有人確認過。",
    "historyTitle": "歷史週費",
    "empty": "仲未有已產生嘅週費。",
    "weekLabel": "{{start}} → {{end}}",
    "draft": "草稿",
    "confirmed": "已確認",
    "totals": "合計（已產生）"
  }
}
